import { namespace } from 'shacl-tulip';

// Namespaces
export const SHACL = namespace('http://www.w3.org/ns/shacl#');
export const RDF = namespace('http://www.w3.org/1999/02/22-rdf-syntax-ns#');
export const DASH = namespace('http://datashapes.org/dash#');
export const RDFS = namespace('http://www.w3.org/2000/01/rdf-schema#');
export const XSD = namespace('http://www.w3.org/2001/XMLSchema#');
export const DLDIST = namespace(
    'https://concepts.datalad.org/s/distribution/unreleased/'
);
export const DLTHING = namespace(
    'https://concepts.datalad.org/s/thing/unreleased/'
);
export const DLTHINGS = namespace('https://concepts.datalad.org/s/things/v2/');
export const DLTYPES = namespace(
    'https://concepts.datalad.org/s/types/v1/'
);
export const DLCO = namespace('https://concepts.datalad.org/');
export const SKOS = namespace('http://www.w3.org/2004/02/skos/core#');
export const SHACLVUE = namespace('https://concepts.datalad.org/ns/shaclvue/');
